import React, { Component } from "react";
import { ToastContainer } from "react-toastify";
import toast from "../helpers/toast";
import Httpconfig from "../helpers/HttpconfigDiagnostics";
import Constant from "../../constants";
import { MDBDataTable, MDBBadge, MDBContainer } from "mdbreact";
import DiagnosisHeader from "./DiagnosisHeader";
import DiagnosisMenu from "./DiagnosisMenu";
import { Link } from "react-router-dom";
import * as SecureLS from "secure-ls";
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});

export default class ViewDiagnosticsBanners extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page_data: "",
      datatable: {
        columns: [
          { label: "Banner Name", field: "banner_name", sort: "asc", width: 150 },
          { label: "Position", field: "position", sort: "asc", width: 120 },
          { label: "Start Date", field: "start_date", sort: "asc", width: 150 },
          { label: "End Date", field: "end_date", sort: "asc", width: 150 },
          { label: "Redirection Tags", field: "redirection_tags", sort: "asc", width: 120 },
          { label: "Images", field: "images", sort: "asc", width: 120 },
          { label: "Status", field: "status", sort: "asc", width: 100 },
          { label: "Actions", field: "actions", sort: "asc", width: 100 }
        ],
        rows: [],
      },
    };
    this.deleteBanner = this.deleteBanner.bind(this);
  }

  // To get detais after first render
  componentDidMount = () => {
    let userData = ls.get("diagnosticsuserObj");
    if (userData && userData !== "") {
        this.setState({ diagnosisId: userData.diagnosis_id });
        this.fetchBannersData(userData.diagnosis_id);
    } else {
        window.location.href = "/diagnostics/login";
    }
};

  // When value changes of the fields
  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  updateBannerStatus = (bannerId, currentStatus) => {
    // Toggle status: active <-> inactive
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    Httpconfig.httptokenput(`${Constant.siteurl}api/OM/Banners/ActiveInactive/${newStatus}/${bannerId}`)
      .then((response) => {
        toast.success(response.data.message || "Successfully updated status");
        this.fetchBannersData(this.state.diagnosisId);
      })
      .catch((error) => {
        toast.error("Failed to update status");
      });
  };

  fetchBannersData(entity_id) {
    const payload = {
        module_type: "diagnostics",
        status: '',
        search: "",
        page: 1,
        limit: 10,
        entity_id: entity_id
    };
    Httpconfig.httptokenpost(Constant.siteurl+"api/OM/Banners/list", payload)
        .then((response) => {
            const banners = response.data.data || [];
            let assignvalues = banners.map((item, key) => ({
                banner_name: item.banner_name || '--',
                position: item.position || '--',
                start_date: item.start_date || '--',
                end_date: item.end_date || '--',
                redirection_tags: item.redirection_tags || '--',
                status: (
                    <MDBBadge
                      color={item.status === "active" ? "success" : "warning"}
                      style={{ cursor: "pointer" }}
                      onClick={() => this.updateBannerStatus(item.banner_id, item.status)}
                      title={`Click to ${item.status === "active" ? "deactivate" : "activate"} this banner`}
                    >
                      {(item.status && item.status.charAt(0).toUpperCase() + item.status.slice(1)) || '--'}
                    </MDBBadge>
                ),
                images: (
                    <div style={{ display: "flex", gap: "5px" }}>
                        {item.images && item.images.length > 0 ? item.images.map((img, idx) => (
                          <a key={img.image_id}
                        href={img.image_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >

                            <img
                                key={img.image_id}
                                src={img.image_url}
                                alt={img.alt_text || `Banner ${idx + 1}`}
                                style={{ width: 40, height: 40, objectFit: "cover", borderRadius: 4, border: "1px solid #ccc" }}
                            />
                            </a>
                        )) : '--'}
                        
                    </div>
                ),
                actions: (
                    <div>
                        <span>
                            <Link
                                to={`/diagnostics/DiagnosticsBanners/${item.banner_id}`}
                                className="fa fa-edit point-cursor"
                                title={`Update ${item.banner_name}`}
                            ></Link>
                        </span>
                        &nbsp;
                        <span>
                          <i
                            onClick={() => this.deleteBanner(item.banner_id, item.banner_name)}
                            className="fa fa-trash point-cursor"
                            title={`Delete ${item.banner_name}`}
                            style={{ color: "red", cursor: "pointer" }}
                          ></i>
                        </span>
                      </div>
                )
            }));

            let datatable = { ...this.state.datatable };
            datatable.rows = assignvalues;
            this.setState({ datatable });
        })
        .catch((error) => { });
}
  //delete controller
  deleteBanner(bannerId, bannerName) {
    const isConfirm = window.confirm(`Are you sure to delete ${bannerName}?`);
    if (isConfirm) {
      Httpconfig.httptokendelete(`${Constant.siteurl}api/OM/Banners/${bannerId}`)
        .then((response) => {
          toast.success("Successfully Deleted Banner");
          setTimeout(() => window.location.reload(), 2000);
        })
        .catch((error) => { });
    }
  }
  render() {
    const { datatable } = this.state;
    return (
      <main id="main">
        <DiagnosisHeader />
        <DiagnosisMenu />
        <section id="Pharmacy_dashboard">
          <div className="Pharma_Content">
            <div className="container-fluid">
              <div className="create-coupon-page">
                <div className="row ">
                  <div className="col-md-12">
                    <form>
                      <div className="tab-header create-coupon-header">
                        <h3> Banners</h3>
                        <Link
                          to="/diagnostics/DiagnosticsBanners"
                          className="btn  btn-primary fright"
                        >
                          Create Banner
                        </Link> 
                        </div>
                    </form>
                  </div>
                </div>
                <div className="row">
                  <div id="" className="viewcoupons">                          
                    {datatable.rows.length === 0 ? (
                      <p>No Banners Found</p>
                    ) : (
                      <MDBDataTable
                        responsive
                        striped
                        bordered
                        small
                        data={datatable}
                      />
                    )}

                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="update_btn"
                          style={{ textAlign: "right" }}
                        ></div>
                      </div>
                    </div>
                    <ToastContainer />
                  </div>
                </div>
              </div>
            </div>
          </div>                 
        </section>
      </main>
    );
  }
}
